import React from 'react';
import { connect } from 'react-redux';
import Anchor from 'Components/common/Anchor';
import { ArrowBackIos } from '@material-ui/icons';
import { Grid, Card } from '@material-ui/core';
import ReplenishmentProductDetails from 'Components/replenishment/ReplenishmentProductDetails';
import { viewF1Order } from 'Actions/replenishment';
import { T } from 'Actions/translate';

class ShippedOrderDetials extends React.Component {

    componentWillMount() {
        const { localData } = this.props;

        this.props.viewF1Order(localData.orderId);
    }

    goBack = () => this.props.history.goBack();

    render() {
        const { f1OrderDetails } = this.props;

        return (
            <div className="admin-f1-order-details">

                <Grid className='page-title-container no-margin container-max-width is-fixed' container spacing={0} justify={'space-evenly'}>

                    <Grid className='go-back' item xs={2}>
                        <Anchor onClickOfSingleTap={ this.goBack }><ArrowBackIos/></Anchor>
                    </Grid>

                    <Grid className='page-title' item xs={8}>
                        <span>{T('fone_order_details')}</span>
                    </Grid>

                    <Grid item xs={2}></Grid>
                </Grid>

                <div className='background-cover'></div>

                <Card className="sc-info">
                    <Grid className='sc-info-container' container spacing={0}>

                        <Grid className='sc-info-title' item xs={11}>
                            <span>{f1OrderDetails.supplyCenterName}</span>
                        </Grid>

                        <Grid className='sc-info-details' item xs={11}>
                            <span>{T('fone_order_number', [f1OrderDetails.number])}</span>
                        </Grid>

                        <Grid className='sc-info-details' item xs={11}>
                            <span>{T('fone_order_eone_number', [f1OrderDetails.eoneNumber])}</span>
                        </Grid>

                        <Grid className='sc-info-details' item xs={11}>
                            <span>{T('fone_order_eone_status')}{T(f1OrderDetails.eoneStatus)}</span> 
                        </Grid>

                        <Grid className='sc-info-details' item xs={11}>
                            <span>{T('fone_order_details_replenishment_date', [f1OrderDetails.createTime])}</span>
                        </Grid>

                    </Grid>

                </Card>

                <Card className="replenishment-info">
                    <Grid className='replenishment-info-container' container spacing={0}>

                        <Grid className='replenishment-info-title' item xs={12}>
                            <span>{T('fone_order_replenishment_information')}</span>
                        </Grid>

                        <Grid className='replenishment-info-details' item xs={12}>
                            {   f1OrderDetails.orderProducts && f1OrderDetails.orderProducts.map((item, i) => {
                                    return  <ReplenishmentProductDetails key={i} f1OrderProduct={item} />
                                })
                            }
                        </Grid>
                    </Grid>

                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { replenishment, localData } = state;
	return {
        f1OrderDetails: replenishment.f1OrderDetails,
        localData: localData
	};
};

const mapDispatchToProps = {
    viewF1Order
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippedOrderDetials);
